module.exports = {
  levels: {
    info: 'info',
    warning: 'warning',
    error: 'error',
    debug: 'debug',
  },
  toStackDriverNumericLevel(severity) {
    switch (severity) {
      case this.levels.warning:
        return 400;
      case this.levels.error:
        return 500;
      default:
        return 200;
    }
  }
}
